import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { AccountantService } from "./accountant.service";
import { DashboardService } from "../../dashboard.service";
import { GeneralUtil } from "../../../utils/general";
import { HotToastService } from "@ngneat/hot-toast";
import { NgIf } from "@angular/common";
import { ResourcesWidgetComponent } from "../common/resources.component";
import { AppsWidgetComponent } from "../common/apps.component";
import { InitialsDirective } from "../../../utils/initials.directive";

@Component({
    selector: "app-gateway-preview",
    templateUrl: "./gateway-preview.component.html",
    styleUrls: [],
    imports: [
        InitialsDirective,
        AppsWidgetComponent,
        ResourcesWidgetComponent,
        NgIf,
    ]
})
export class GatewayPreviewComponent implements OnInit {
  user: any = {};
  company: any = {};

  constructor(private localStorage: LocalStorageService) {}

  ngOnInit(): void {
    this.company = this.localStorage.get("client_preview");
    this.user = this.localStorage.get("user_preview");

    console.log(this.user);
  }
}
